var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomwave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 124.603,
    viewBox: "0 0 1440 124.603",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bottomwave",
    transform: "translate(0 0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M1256,11.76c-18.8,5.5-46.6,15.8-86,14-42.8-1.9-44.7-15.6-83-18-60.1-3.8-72,28.8-128,22-38.9-4.7-37.7-20.9-75-22-42.7-1.2-49.6,19.9-94,20-40.2.1-41.5-17.1-83-18-44.5-1-48.8,18.7-96,22-47.9,3.3-51-16.5-107-18-51.5-1.4-54,15.2-108,16-59.3.8-63.4-20.4-116.9-19-62.8,1.6-76.8,29.6-133.1,33-33.2,2-83-1.8-146-33V124.6H1440V10.76C1353.8-7.34,1294.8.46,1256,11.76Z",
    fill: "#f9fde5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomwave);
export default __webpack_public_path__ + "static/media/bottomwave.3ce96650acd116ed35ea1745fb37081a.svg";
export { ForwardRef as ReactComponent };